import VueRouter, { RouteConfig } from 'vue-router'
import { GlobalConfigRouteMetaEnum, CompetitionRegionDetailsTabItemName } from 'kuaidong-model'

const StatsStudent = () => import('../views/competition/StatsStudent.vue')
const RegionDetails = () => import('../views/CompetitionRegionDetails.vue')
const RegionDetailsV2 = () => import('../views/competition-area-v2/CompetitionAreaDetailsV2.vue')
const RegionEnroll = () => import('../views/competition-area-v2/CompetitionAreaEnroll.vue')
const RegionRankV2 = () => import('../views/competition-area-v2/CompetitionAreaRankV2.vue')
const RegionFinalScoreV2 = () => import('../views/competition-area-v2/CompetitionAreaFinalScoreV2.vue')
const RegionFinalSchoolScoreV2 = () => import('../views/competition-area-v2/CompetitionAreaFinalSchoolScoreV2.vue')
const AreaDrillDetailsV2 = () => import('../views/competition-area-v2/CompetitionAreaSingleDrillDetailsV2.vue')
const RegionDrillDetails = () => import('../views/CompetitionRegionDrillDetails.vue')

export const statsStudentRoute: RouteConfig = {
  path: '/compeition-stats-student',
  name: 'competition_stats_student',
  component: StatsStudent,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '学生比赛详情',
    [GlobalConfigRouteMetaEnum.All]: true,
    keepAlive: true,
  },
}

export const regionDetailsRoute: RouteConfig = {
  path: '/competition-region-details',
  name: 'competition_region_details',
  component: RegionDetails,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '比赛详情',
  },
}

export const regionDetailsV2Route: RouteConfig = {
  path: '/competition-region-details-v2',
  name: 'competition_region_details_v2',
  component: RegionDetailsV2,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '比赛详情',
  },
}

export const regionRankV2Route: RouteConfig = {
  path: '/competition-region-rank-v2',
  name: 'competition_region_rank_v2',
  component: RegionRankV2,
  meta: {
    title: '比赛排行榜',
  },
}

export const regionEnrollRoute: RouteConfig = {
  path: '/competition-region-enroll',
  name: 'competition_region_enroll',
  component: RegionEnroll,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '比赛报名详情',
  },
}

export const regionFinalSchoolScoreV2Route: RouteConfig = {
  path: '/competition-region-final-school-score-v2',
  name: 'competition_region_final_school_score_v2',
  component: RegionFinalSchoolScoreV2,
  meta: {
    title: '获奖名单',
  },
}

export const regionFinalScoreV2Route: RouteConfig = {
  path: '/competition-region-final-score-v2',
  name: 'competition_region_final_score_v2',
  component: RegionFinalScoreV2,
  meta: {
    title: '完整获奖名单',
  },
}

export const areaDrillDetailsV2Route: RouteConfig = {
  path: '/competition-area-drill-details-v2',
  name: 'competition_area_drill_details_v2',
  component: AreaDrillDetailsV2,
  props: (route) => ({
    ...route.query,
    ...route.params,
    awardStatus: route.query.awardStatus && +route.query.awardStatus,
  }),
  meta: {
    title: '比赛详情',
    [GlobalConfigRouteMetaEnum.All]: true,
    keepAlive: true,
  },
}

export const regionDrillDetailsRoute: RouteConfig = {
  path: '/competition-region-drill-details',
  name: 'competition_region_drill_details',
  component: RegionDrillDetails,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '比赛详情',
  },
}

export const launchRoute: RouteConfig = {
  path: '/competition-launch',
  name: 'competition_launch',
  props: (route) => ({ ...route.query, ...route.params }),
  component: () => import('@/views/competition-launch/StepRoot.vue'),
  meta: {
    title: '发起比赛',
  },

  children: [
    {
      path: 'step1',
      name: 'competition_launch_step1',
      component: () => import('../views/competition-launch/Step1.vue'),
      meta: {
        stepTitle: '比赛类型',
        title: '创建校内赛',
        nextStep: 'competition_launch_step2',
        [GlobalConfigRouteMetaEnum.All]: true,
      },
      props: (route) => ({
        currentStep: Number(route.query.currentStep),
        totalSteps: Number(route.query.totalSteps),
      }),
    },
    {
      path: 'step2',
      name: 'competition_launch_step2',
      component: () => import('@/views/competition-launch/Step2.vue'),
      meta: {
        stepTitle: '选择项目',
        title: '创建校内赛',
        nextStep: 'competition_launch_step3',
        [GlobalConfigRouteMetaEnum.All]: true,
      },
      props: (route) => ({
        currentStep: Number(route.query.currentStep),
        totalSteps: Number(route.query.totalSteps),
        // drills: JSON.parse((route.query.drills || '[]') as string),
      }),
    },
    {
      path: 'step3',
      name: 'competition_launch_step3',
      component: () => import('@/views/competition-launch/Step3.vue'),
      meta: {
        stepTitle: '参赛规则',
        title: '创建校内赛',
        nextStep: 'competition_launch_step4',
        [GlobalConfigRouteMetaEnum.All]: true,
      },
      props: (route) => ({
        currentStep: Number(route.query.currentStep),
        totalSteps: Number(route.query.totalSteps),
      }),
    },
    {
      path: 'step4',
      name: 'competition_launch_step4',
      component: () => import('@/views/competition-launch/Step4.vue'),
      meta: {
        stepTitle: '基础信息',
        title: '创建校内赛',
        nextButtonText: '确定创建',
        [GlobalConfigRouteMetaEnum.All]: true,
      },
      props: (route) => ({
        currentStep: Number(route.query.currentStep),
        totalSteps: Number(route.query.totalSteps),
      }),
    },
    {
      path: 'preview',
      name: 'competition_launch_preview',
      component: () => import('@/views/competition-launch/Preview.vue'),
      props: (route) => ({
        id: route.query.id,
      }),
      meta: {
        title: '比赛预览',
        [GlobalConfigRouteMetaEnum.All]: true,
      },
    },
    {
      path: 'drills',
      name: 'competition_launch_drills',
      component: () => import('@/views/competition-launch/DrillSelector.vue'),
      meta: {
        title: '添加项目',
        [GlobalConfigRouteMetaEnum.All]: true,
      },
    },
  ],
}

const RCompetition: RouteConfig[] = [
  {
    path: '/competition-list',
    name: 'competition_list',
    component: () => import('../views/CompetitionList.vue'),
    props: (route) => ({ ...route.query, ...route.params }),
    meta: {
      title: '比赛列表',
    },
  },
  {
    path: '/competition-type-select',
    name: 'competition_type_select',
    component: () => import('../views/CompetitionTypeSelect.vue'),
    meta: {
      title: '比赛类型',
      [GlobalConfigRouteMetaEnum.All]: true,
    },
  },
  {
    path: '/competition-rules',
    name: 'competition_rules',
    component: () => import('../views/CompetitionRules.vue'),
    meta: {
      title: '比赛规则',
    },
    props: (route) => ({
      competitionType: route.query.competitionType ? JSON.parse(`${route.query.competitionType}`) : null,
    }),
  },
  {
    path: '/competition-form',
    name: 'competition_form',
    component: () => import('../views/CompetitionForm.vue'),
    props: (route) => ({
      competitionType: route.query.competitionType ? JSON.parse(`${route.query.competitionType}`) : null,
      competition: route.query.competition ? JSON.parse(`${route.query.competition}`) : null,
    }),
    meta: {
      title: '比赛规则',
    },
  },
  {
    path: '/competition-detail',
    name: 'competition_detail',
    component: () => import('../views/CompetitionDetail.vue'),
    props: (route) => ({
      competition: route.query.competition ? JSON.parse(`${route.query.competition}`) : null,
    }),
    children: [
      {
        path: '/competition-ranking',
        name: 'competition_ranking',
        component: () => import('../views/CompetitionRanking.vue'),
        meta: {
          title: '比赛详情',
        },
      },
      {
        path: '/competition-stat-grade',
        name: 'competition_stat_grade',
        component: () => import('../views/CompetitionStatGrade.vue'),
        meta: {
          title: '比赛详情',
        },
      },
    ],
  },
  {
    path: '/new-school-competition-detail',
    name: 'new_school_competition_detail',
    component: () => import('../views/NewSchoolCompetitionDetail.vue'),
    props: (route) => ({ ...route.query, ...route.params }),
    meta: {
      title: '比赛详情',
      [GlobalConfigRouteMetaEnum.Drills]: true,
      [GlobalConfigRouteMetaEnum.Homework]: true,
      keepAlive: true,
    },
  },
  {
    path: '/online-sport-competition-detail',
    name: 'online_sport_competition_detail',
    component: () => import('@/views/OnlineSportCompetitionDetail.vue'),
    props: (route) => ({ ...route.query, ...route.params }),
    meta: {
      title: '比赛详情',
      [GlobalConfigRouteMetaEnum.Drills]: true,
      [GlobalConfigRouteMetaEnum.Homework]: true,
    },
  },
  {
    path: '/competition-stat-class',
    name: 'competition_stat_class',
    component: () => import('../views/CompetitionStatClass.vue'),
    meta: {
      title: '年级比赛详情',
    },
  },
  {
    path: '/class-competition-ranking',
    name: 'class_competition_ranking',
    component: () => import('../views/CompetitionRanking.vue'),
    props: (route) => ({
      gradeId: route.query.gradeId ? Number(route.query.gradeId) : null,
      classId: route.query.classId ? Number(route.query.classId) : null,
      className: route.query.className,
    }),
    meta: {
      title: '班级比赛详情',
    },
  },
  {
    path: '/competition-poster',
    name: 'competition_poster',
    component: () => import('../views/CompetitionPoster.vue'),
    props: (route) => ({
      competition: route.query.competition ? JSON.parse(`${route.query.competition}`) : null,
    }),
  },
  regionDetailsRoute,
  regionDetailsV2Route,
  regionRankV2Route,
  regionEnrollRoute,
  regionFinalScoreV2Route,
  regionFinalSchoolScoreV2Route,
  areaDrillDetailsV2Route,
  regionDrillDetailsRoute,
  launchRoute,
  statsStudentRoute,
]

export default RCompetition

export function navigateToCompetitionList(router: VueRouter, activityId?: string) {
  router.push({ name: 'competition_list', query: { activityId } })
}

export function navigateToCompetitionRanking(router: VueRouter, competitionId: number) {
  router.push({ name: 'competition_ranking', query: { competitionId: `${competitionId}` } })
}

export function navigateToCompetitionRegionDetails(
  router: VueRouter,
  id: string,
  tabItem = CompetitionRegionDetailsTabItemName.General
) {
  router.push({ name: regionDetailsRoute.name, query: { id, tabItem } })
}

export function navigateToCompetitionRegionDrillDetails(
  router: VueRouter,
  id: string,
  tabItem = CompetitionRegionDetailsTabItemName.General
) {
  router.push({ name: regionDrillDetailsRoute.name, query: { id, tabItem } })
}

export function navigateToAreaV2DrillDetails(
  router: VueRouter,
  matchId: string,
  gameId: string,
  status: string,
  from?: string,
  awardStatus?: boolean,
  gradeClazzType?: string,
  gradeClazzName?: string,
  gradeClazzId?: string | number
) {
  router.push({
    name: areaDrillDetailsV2Route.name,
    query: {
      matchId,
      gameId,
      status,
      from,
      awardStatus: awardStatus ? '1' : '0',
      gradeClazzType,
      gradeClazzName,
      gradeClazzId: gradeClazzId ? `${gradeClazzId}` : undefined,
    },
  })
}

export function navigateToCompetitionStatsStudent(
  router: VueRouter,
  id: string,
  gameId: string,
  studentId: string,
  from?: string
) {
  router.push({ name: statsStudentRoute.name, query: { id, gameId, studentId, from } })
}
